module.exports = __webpack_public_path__ + "8c726729622a2f393529ca34bc00c4de.pdf";